import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "gatsby";
import React from "react";

const NeedHelpMobile = ({ needHelp = [], aboutUs = [] }) => {
  return (
    <div id="help-about-mobile" className="block md:hidden border-none">
      <Accordion type="multiple" className="w-full px-5" defaultValue="need-help">
        <AccordionItem value="need-help" className="pb-[15px] border-none">
          <AccordionTrigger className="w-full hover:no-underline text-white">
            <h4 className="text-xl grow font-bold text-white text-left tracking-wide">
              Need help?
            </h4>
          </AccordionTrigger>
          <AccordionContent className="pb-4">
            <div className="grid grid-cols-1 gap-3">
              {/* <div> */}
              {needHelp.map((value, id) => {
                if (value.slug.includes("bushbuck-club")) {
                  return (
                    <a
                      href={value.slug}
                      key={id}
                      className="text-white opacity-60 text-sm cursor-pointer hover:text-secondary-500 hover:opacity-100 transition-all duration-200 ease-linear"
                    >
                      {value.title}
                    </a>
                  );
                } else {
                  return (
                    <Link
                      to={value.slug}
                      key={id}
                      className="text-white opacity-60 text-sm cursor-pointer hover:text-secondary-500 hover:opacity-100 transition-all duration-200 ease-linear"
                    >
                      {value.title}
                    </Link>
                  );
                }
              })}
            </div>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="about" className="py-[15px] border-none">
          <AccordionTrigger className="w-full hover:no-underline">
            <h5 className="text-xl grow font-bold text-white text-left tracking-wide">
              About
            </h5>
          </AccordionTrigger>
          <AccordionContent className="pb-2">
            <div className="grid grid-cols-1 gap-2">
              {/* <div> */}
              {aboutUs.map((value, id) => {
                return (
                  <Link
                    to={value.slug}
                    key={id}
                    className="text-white opacity-60 text-sm cursor-pointer hover:text-secondary-500 hover:opacity-100 transition-all duration-200 ease-linear"
                  >
                    {/* Conatact US */}
                    {value.title}
                  </Link>
                );
              })}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default NeedHelpMobile;
